/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
export default {
  es: {
    dictionary: {
      '*Change\x20to:*\x20%0': '*Cambiar\x20a:*\x20%0',
      '*Change\x20%0\x20content*': '*Cambiar\x20el\x20contenido\x20de\x20%0*',
      '*Check\x20item*': '*Comprobar\x20elemento*',
      '*Format:*\x20%0': '*Formato:*\x20%0',
      '*Indent:*\x20%0': '*Sangría:*\x20%0',
      '*Insert:*\x20%0': '*Insertar:*\x20%0',
      '*Format:*\x20change\x20table\x20properties':
        '*Formato:*\x20cambiar\x20las\x20propiedades\x20de\x20la\x20tabla',
      '*Format:*\x20change\x20table\x20cell\x20properties':
        '*Formato:*\x20cambiar\x20las\x20propiedades\x20de\x20la\x20celda\x20de\x20la\x20tabla',
      '*Format:*\x20insert\x20into\x20%0': '*Formato:*\x20insertar\x20en\x20%0',
      '*Format:*\x20remove\x20from\x20%0': '*Formato:*\x20eliminar\x20de\x20%0',
      '*Replace\x20image\x20URL*': '*Reemplazar\x20URL\x20de\x20la\x20imagen*',
      '*Format:*\x20resize\x20table': '*Formato:*\x20redimensionar\x20tabla',
      '*Format:*\x20set\x20order\x20to\x20reversed':
        '*Formato:*\x20establecer\x20orden\x20inverso',
      '*Format:*\x20set\x20order\x20to\x20regular':
        '*Formato:*\x20establecer\x20orden\x20a\x20regular',
      '*Format:*\x20set\x20start\x20index\x20to\x20%0':
        '*Formato:*\x20establecer\x20el\x20índice\x20de\x20inicio\x20en\x20%0',
      '*Merge\x20cells*': '*Combinar\x20celdas*',
      '*Merge:*\x20%0': '*Combinar:*\x20%0',
      '*Outdent:*\x20%0': '*Eliminar\x20sangría:*\x20%0',
      '*Remove\x20all\x20formatting*': '*Eliminar\x20todo\x20el\x20formato*',
      '*Remove\x20format:*\x20%0': '*Eliminar\x20formato:*\x20%0',
      '*Remove\x20highlight*': '*Eliminar\x20resaltado*',
      '*Remove\x20image\x20text\x20alternative*':
        '*Eliminar\x20alternativa\x20de\x20texto\x20de\x20la\x20imagen*',
      '*Remove\x20link*': '*Eliminar\x20enlace*',
      '*Remove:*\x20%0': '*Eliminar:*\x20%0',
      '*Replace\x20table\x20cells*': '*Reemplazar\x20celdas\x20de\x20tabla*',
      '*Reset\x20font\x20background\x20color*':
        '*Restablecer\x20color\x20de\x20fondo\x20de\x20la\x20fuente*',
      '*Reset\x20font\x20color*': '*Restablecer\x20color\x20de\x20fuente*',
      '*Reset\x20font\x20family*': '*Restablecer\x20familia\x20de\x20fuentes*',
      '*Reset\x20font\x20size*': '*Restablecer\x20tamaño\x20de\x20fuente*',
      '*Reset\x20image\x20width*': '*Restablecer\x20ancho\x20de\x20imagen*',
      '*Set\x20font\x20background\x20color:*\x20%0':
        '*Establecer\x20color\x20de\x20fondo\x20de\x20la\x20fuente:*\x20%0',
      '*Set\x20font\x20color:*\x20%0':
        '*Establecer\x20color\x20de\x20fuente:*\x20%0',
      '*Set\x20font\x20family:*\x20%0':
        '*Establecer\x20familia\x20de\x20fuentes:*\x20%0',
      '*Set\x20font\x20size:*\x20%0':
        '*Establecer\x20tamaño\x20de\x20fuente:*\x20%0',
      '*Set\x20format:*\x20%0': '*Establecer\x20formato:*\x20%0',
      '*Set\x20format\x20to:*\x20%0': '*Establecer\x20formato\x20en:*\x20%0',
      '*Set\x20highlight:*\x20%0': '*Establecer\x20resaltado:*\x20%0',
      '*Set\x20image\x20text\x20alternative:*\x20%0':
        '*Establecer\x20alternativa\x20de\x20texto\x20de\x20la\x20imagen:*\x20%0',
      '*Set\x20image\x20width:*\x20%0':
        '*Establecer\x20ancho\x20de\x20imagen:*\x20%0',
      '*Set\x20link:*\x20%0': '*Establecer\x20enlace:*\x20%0',
      '*Split\x20cell:*\x20horizontally':
        '*Dividir\x20celda:*\x20horizontalmente',
      '*Split\x20cell:*\x20vertically': '*Dividir\x20celda:*\x20verticalmente',
      '*Split:*\x20%0': '*Dividir:*\x20%0',
      '*Uncheck\x20item*': '*Desmarcar\x20elemento*',
      'Accept\x20all\x20selected\x20suggestions':
        'Aceptar\x20todas\x20las\x20sugerencias\x20seleccionadas',
      'Accept\x20all\x20suggestions': 'Aceptar\x20todas\x20las\x20sugerencias',
      'Accept\x20suggestion': 'Aceptar\x20sugerencia',
      'Discard\x20all\x20selected\x20suggestions':
        'Descartar\x20todas\x20las\x20sugerencias\x20seleccionadas',
      'Discard\x20all\x20suggestions':
        'Descartar\x20todas\x20las\x20sugerencias',
      'Discard\x20suggestion': 'Descartar\x20sugerencia',
      LEAVE_INSERTION_SUGGESTION_ANNOUNCEMENT:
        'Abandonando\x20sugerencia\x20de\x20inserción.',
      ENTER_INSERTION_SUGGESTION_ANNOUNCEMENT:
        'Introduciendo\x20sugerencia\x20de\x20inserción.',
      LEAVE_DELETION_SUGGESTION_ANNOUNCEMENT:
        'Abandonando\x20sugerencia\x20de\x20borrado.',
      ENTER_DELETION_SUGGESTION_ANNOUNCEMENT:
        'Introduciendo\x20sugerencia\x20de\x20borrado.',
      LEAVE_FORMATTING_SUGGESTION_ANNOUNCEMENT:
        'Abandonando\x20sugerencia\x20de\x20formato.',
      ENTER_FORMATTING_SUGGESTION_ANNOUNCEMENT:
        'Introduciendo\x20sugerencia\x20de\x20formato.',
      ELEMENT_BLOCK_QUOTE: 'bloque\x20de\x20cita',
      ELEMENT_DEFAULT_LIST_DEFAULT: 'estilo\x20de\x20lista\x20predeterminado',
      ELEMENT_BULLETED_LIST: 'lista\x20con\x20topos',
      ELEMENT_BULLETED_LIST_DEFAULT:
        'lista\x20con\x20viñetas\x20(predeterminada)',
      ELEMENT_BULLETED_LIST_CIRCLE: 'lista\x20con\x20viñetas\x20(círculo)',
      ELEMENT_BULLETED_LIST_DISC: 'lista\x20con\x20viñetas\x20(disco)',
      ELEMENT_BULLETED_LIST_SQUARE: 'lista\x20con\x20viñetas\x20(cuadrado)',
      ELEMENT_CAPTION: 'Subtítulo',
      ELEMENT_CODE_BLOCK: [
        'Bloque\x20de\x20código',
        '%0\x20bloques\x20de\x20código',
        '%0\x20bloques\x20de\x20código',
      ],
      ELEMENT_HEADING: [
        'encabezado\x20(nivel\x20%1)',
        '%0\x20encabezados\x20(nivel\x20%1)',
        '%0\x20encabezados\x20(nivel\x20%1)',
      ],
      ELEMENT_HEADING_CUSTOM: [
        'encabezado\x20(%1)',
        '%0\x20encabezados\x20(%1)',
        '%0\x20encabezados\x20(%1)',
      ],
      ELEMENT_HORIZONTAL_LINE: [
        'Línea\x20horizontal',
        '%0\x20líneas\x20horizontales',
        '%0\x20líneas\x20horizontales',
      ],
      ELEMENT_HTML_EMBED: [
        'HTML\x20incrustado',
        '%0\x20HTML\x20incrustado',
        '%0\x20HTML\x20incrustado',
      ],
      ELEMENT_IMAGE: ['imagen', '%0\x20imágenes', '%0\x20imágenes'],
      ELEMENT_INLINE_IMAGE: ['imagen', '%0\x20imágenes', '%0\x20imágenes'],
      ELEMENT_LINE_BREAK: [
        'Salto\x20de\x20línea',
        '%0\x20Salto\x20de\x20línea',
        '%0\x20Salto\x20de\x20línea',
      ],
      ELEMENT_LIST_ITEM: [
        'ítem\x20de\x20lista',
        '%0\x20items\x20de\x20lista',
        '%0\x20items\x20de\x20lista',
      ],
      ELEMENT_MEDIA: [
        'Elemento\x20multimedia',
        '%0\x20elemento\x20multimedia',
        '%0\x20elemento\x20multimedia',
      ],
      ELEMENT_NUMBERED_LIST: 'Lista\x20numerada',
      ELEMENT_NUMBERED_LIST_DEFAULT: 'lista\x20numerada\x20(predeterminada)',
      ELEMENT_NUMBERED_LIST_DECIMAL: 'lista\x20numerada\x20(decimal)',
      ELEMENT_NUMBERED_LIST_DECIMAL_LEADING_ZERO:
        'lista\x20numerada\x20(decimal\x20con\x20cero\x20inicial)',
      ELEMENT_NUMBERED_LIST_LOWER_LATIN:
        'lista\x20numerada\x20(letras\x20ASCII\x20en\x20minúscula)',
      ELEMENT_NUMBERED_LIST_LOWER_ROMAN:
        'lista\x20numerada\x20(números\x20romanos\x20en\x20minúscula)',
      ELEMENT_NUMBERED_LIST_UPPER_LATIN:
        'lista\x20numerada\x20(letras\x20ASCII\x20en\x20mayúscula)',
      ELEMENT_NUMBERED_LIST_UPPER_ROMAN:
        'lista\x20numerada\x20(números\x20romanos\x20en\x20mayúscula)',
      ELEMENT_PAGE_BREAK: [
        'Salto\x20de\x20página',
        '%0\x20salto\x20de\x20página',
        '%0\x20salto\x20de\x20página',
      ],
      ELEMENT_PARAGRAPH: ['párrafo', '%0\x20párrafos', '%0\x20párrafos'],
      ELEMENT_SPACE: ['espacio', '%0\x20espacios', '%0\x20espacios'],
      ELEMENT_TABLE: ['tabla', '%0\x20tablas', '%0\x20tablas'],
      ELEMENT_TABLE_COLUMN: [
        'columna\x20de\x20tabla',
        '%0\x20columnas\x20de\x20tabla',
        '%0\x20columnas\x20de\x20tabla',
      ],
      ELEMENT_TABLE_COLUMN_WITH_TEXT: [
        'columna\x20de\x20tabla\x20*con\x20texto*\x20%1',
        '%0\x20columnas\x20de\x20tabla\x20*con\x20texto*\x20%1',
        '%0\x20columnas\x20de\x20tabla\x20*con\x20texto*\x20%1',
      ],
      ELEMENT_TABLE_OF_CONTENTS: [
        'tabla\x20de\x20contenido',
        'tabla\x20de\x20contenido',
        'tabla\x20de\x20contenido',
      ],
      ELEMENT_TABLE_ROW: [
        'fila\x20de\x20tabla',
        '%0\x20filas\x20de\x20tabla',
        '%0\x20filas\x20de\x20tabla',
      ],
      ELEMENT_TABLE_ROW_WITH_TEXT: [
        'fila\x20de\x20tabla\x20*con\x20texto*\x20%1',
        '%0\x20filas\x20de\x20tabla\x20*con\x20texto*\x20%1',
        '%0\x20filas\x20de\x20tabla\x20*con\x20texto*\x20%1',
      ],
      ELEMENT_TABLE_WITH_TEXT: 'tabla\x20*con\x20texto*\x20%0',
      ELEMENT_TITLE: 'título',
      ELEMENT_TODO_LIST: 'lista\x20de\x20pendientes',
      ELEMENT_MULTI_LEVEL_LIST: 'lista\x20multinivel',
      FORMAT_ALIGNMENT: 'alineación',
      FORMAT_ALIGN_TO_CENTER: 'alinear\x20al\x20centro',
      FORMAT_ALIGN_TO_LEFT: 'alinear\x20a\x20la\x20izquierda',
      FORMAT_ALIGN_TO_RIGHT: 'alinear\x20a\x20la\x20derecha',
      FORMAT_BOLD: 'negrita',
      FORMAT_CODE: 'código',
      FORMAT_HEADER_COLUMN: 'columna\x20de\x20cabecera',
      FORMAT_HEADER_ROW: 'fila\x20de\x20cabecera',
      FORMAT_HIGHLIGHT: 'resalte',
      FORMAT_ITALIC: 'itálica',
      FORMAT_JUSTIFY_TEXT: 'justificar',
      FORMAT_REGULAR_COLUMN: 'columna\x20normal',
      FORMAT_REGULAR_ROW: 'fila\x20normal',
      FORMAT_RESTRICTED_DISABLED:
        '*Desactivar\x20en\x20modo\x20de\x20edición\x20restringida*',
      FORMAT_RESTRICTED_ENABLED:
        '*Activar\x20en\x20modo\x20de\x20edición\x20restringida*',
      FORMAT_SIDE_IMAGE: 'imagen\x20lateral',
      FORMAT_STRIKETHROUGH: 'tachado',
      FORMAT_SUBSCRIPT: 'subíndice',
      FORMAT_SUPERSCRIPT: 'superíndice',
      FORMAT_UNDERLINE: 'subrayado',
      FORMAT_INDENT: 'sangrado',
      FORMAT_LIST_REVERSED: 'lista\x20invertida',
      FORMAT_LIST_START: 'inicio\x20de\x20lista',
      FORMAT_FONT_SIZE: 'tamaño\x20de\x20fuente',
      FORMAT_FONT_FAMILY: 'familia\x20tipográfica',
      FORMAT_FONT_COLOR: 'color\x20de\x20fuente',
      FORMAT_FONT_BACKGROUND: 'color\x20de\x20fondo\x20de\x20la\x20fuente',
      FORMAT_IMAGE_SIZE: 'tamaño\x20de\x20imagen',
      FORMAT_STYLE: 'estilo',
      PENDING_ACTION_SUGGESTION:
        'No\x20se\x20ha\x20guardado\x20el\x20cambio\x20en\x20la\x20sugerencia.',
      REPLACE_TEXT: '*Reemplazar*\x20%0\x20*con*\x20%1',
      'Track\x20changes': 'Control\x20de\x20cambios',
      EXTERNAL_SUGGESTION:
        'Esta\x20sugerencia\x20procede\x20de\x20una\x20fuente\x20externa.',
      EXTERNAL_IMPORT_WORD_SUGGESTION:
        'Esta\x20sugerencia\x20proviene\x20de\x20un\x20archivo\x20de\x20Word\x20importado.',
      Template: 'Plantilla',
      'Insert\x20template': 'Insertar\x20plantilla',
      'No\x20templates\x20available.':
        'No\x20hay\x20plantillas\x20disponibles.',
      'No\x20templates\x20were\x20found\x20matching\x20\x22%0\x22.':
        'No\x20se\x20han\x20encontrado\x20plantillas\x20que\x20coincidan\x20con\x20«%0».',
      'Please\x20try\x20a\x20different\x20phrase\x20or\x20check\x20the\x20spelling.':
        'Intente\x20con\x20una\x20frase\x20diferente\x20o\x20revise\x20la\x20ortografía.',
      'Search\x20template': 'Buscar\x20plantilla',
      '%0\x20templates\x20found': 'Se\x20han\x20encontrado\x20%0\x20plantillas',
      'Create\x20a\x20block\x20quote': 'Crear\x20una\x20cita\x20en\x20bloque',
      'Create\x20a\x20bulleted\x20list':
        'Crear\x20una\x20lista\x20con\x20viñetas',
      'Create\x20a\x20code\x20block': 'Crear\x20un\x20bloque\x20de\x20código',
      'Open\x20file\x20manager\x20to\x20insert\x20an\x20image\x20or\x20a\x20file':
        'Abrir\x20gestor\x20de\x20archivos\x20para\x20insertar\x20una\x20imagen\x20o\x20un\x20archivo',
      'Open\x20file\x20browser\x20to\x20insert\x20an\x20image\x20or\x20a\x20file':
        'Abrir\x20explorador\x20de\x20archivos\x20para\x20insertar\x20una\x20imagen\x20o\x20un\x20archivo',
      'Create\x20a\x20heading\x20level\x201':
        'Crear\x20un\x20encabezado\x20de\x20nivel\x201',
      'Create\x20a\x20heading\x20level\x202':
        'Crear\x20un\x20encabezado\x20de\x20nivel\x202',
      'Create\x20a\x20heading\x20level\x203':
        'Crear\x20un\x20encabezado\x20de\x20nivel\x203',
      'Create\x20a\x20heading\x20level\x204':
        'Crear\x20un\x20encabezado\x20de\x20nivel\x204',
      'Create\x20a\x20heading\x20level\x205':
        'Crear\x20un\x20encabezado\x20de\x20nivel\x205',
      'Create\x20a\x20heading\x20level\x206':
        'Crear\x20un\x20encabezado\x20de\x20nivel\x206',
      'Insert\x20a\x20horizontal\x20line':
        'Insertar\x20una\x20línea\x20horizontal',
      'Insert\x20an\x20HTML\x20snippet':
        'Insertar\x20un\x20fragmento\x20de\x20HTML',
      'Increase\x20the\x20indentation': 'Aumentar\x20la\x20sangría',
      'Insert\x20Mermaid\x20diagram': 'Insertar\x20diagrama\x20de\x20sirena',
      'Insert\x20the\x20Mermaid\x20diagram':
        'Insertar\x20el\x20diagrama\x20de\x20sirena',
      'Create\x20a\x20table': 'Crear\x20una\x20tabla',
      'Insert\x20table\x20of\x20contents':
        'Insertar\x20tabla\x20de\x20contenido',
      'Create\x20a\x20numbered\x20list': 'Crear\x20una\x20lista\x20numerada',
      'Decrease\x20the\x20indentation': 'Disminuir\x20la\x20sangría',
      'Insert\x20a\x20paragraph': 'Insertar\x20un\x20párrafo',
      'Create\x20a\x20to-do\x20list':
        'Crear\x20una\x20lista\x20de\x20tareas\x20pendientes',
      'Open\x20the\x20AI\x20Assistant\x20to\x20generate\x20content':
        'Abre\x20el\x20asistente\x20de\x20IA\x20para\x20generar\x20contenido',
      Restored: 'Restaurada',
      'Empty\x20document': 'Documento\x20vacío',
      'Initial\x20revision': 'Revisión\x20inicial',
      'Compare\x20against\x20selected': 'Comparar\x20con\x20lo\x20seleccionado',
      'Name\x20this\x20revision': 'Nombre\x20esta\x20revisión',
      'Revision\x20creator': 'Creador\x20de\x20la\x20revisión',
      'Revision\x20author': 'Autor\x20de\x20la\x20revisión',
      'Revision\x20name': 'Nombre\x20de\x20la\x20revisión',
      'Name\x20of\x20the\x20revision': 'Nombre\x20de\x20la\x20revisión',
      optional: 'opcional',
      'Save\x20current\x20revision': 'Guardar\x20la\x20revisión\x20actual',
      'Open\x20revision\x20history':
        'Abrir\x20el\x20historial\x20de\x20revisiones',
      'Revision\x20history': 'Historial\x20de\x20revisiones',
      'Suggested\x20by': 'Sugerido\x20por',
      'Added\x20by': 'Añadido\x20por',
      'Removed\x20by': 'Eliminado\x20por',
      'Loading...': 'Cargando…',
      'No\x20changes': 'Sin\x20cambios',
      NUMBER_OF_CHANGES: ['%0\x20cambio', '%0\x20cambios', '%0\x20cambios'],
      X_OF_Y_CHANGES: '%0\x20de\x20%1',
      'Show\x20previous\x20change': 'Ver\x20cambio\x20anterior',
      'Show\x20next\x20change': 'Ver\x20siguiente\x20cambio',
      Total: 'Total',
      EDIT_X_OF_Y_REVISIONS: 'Editar',
      'Back\x20to\x20editing': 'Volver\x20a\x20la\x20edición',
      'Restore\x20this\x20revision': 'Restaurar\x20esta\x20revisión',
      PENDING_ACTION_REVISION_HISTORY:
        'Cambios\x20no\x20guardados\x20en\x20el\x20historial\x20de\x20revisiones.',
      'Enter\x20the\x20revision\x20name':
        'Introduzca\x20el\x20nombre\x20de\x20la\x20revisión',
      'The\x20revision\x20name\x20cannot\x20be\x20empty.':
        'El\x20nombre\x20de\x20la\x20revisión\x20no\x20puede\x20estar\x20vacío.',
      CONNECTED_USERS: [
        '1\x20usuario\x20conectado\x20(yo)',
        '%0\x20usuarios\x20conectados',
        '%0\x20usuarios\x20conectados',
      ],
      PENDING_ACTION_SENDING_DATA: 'Enviando\x20datos\x20al\x20servidor.',
      'Synchronization\x20issue': 'Problema\x20de\x20sincronización',
      'The\x20document\x20cannot\x20be\x20connected\x20back\x20to\x20the\x20server.\x20To\x20not\x20lose\x20your\x20content\x20save\x20it\x20locally\x20and\x20refresh\x20the\x20editor.':
        'El\x20documento\x20no\x20se\x20puede\x20volver\x20a\x20conectar\x20con\x20el\x20servidor.\x20Para\x20no\x20perder\x20su\x20contenido,\x20guárdelo\x20localmente\x20y\x20actualice\x20el\x20editor.',
      'The\x20document\x20details\x20could\x20not\x20be\x20taken\x20during\x20the\x20reconnection.\x20To\x20not\x20lose\x20your\x20content\x20save\x20it\x20locally\x20and\x20refresh\x20the\x20editor.':
        'Los\x20detalles\x20del\x20documento\x20no\x20se\x20pudieron\x20obtener\x20durante\x20la\x20reconexión.\x20Para\x20no\x20perder\x20su\x20contenido,\x20guárdelo\x20localmente\x20y\x20actualice\x20el\x20editor.',
      'The\x20last\x20saved\x20version\x20of\x20the\x20document\x20does\x20not\x20match\x20the\x20local\x20version.\x20To\x20not\x20lose\x20your\x20content\x20save\x20it\x20locally\x20and\x20refresh\x20the\x20editor.':
        'La\x20última\x20versión\x20guardada\x20del\x20documento\x20no\x20coincide\x20con\x20la\x20versión\x20local.\x20Para\x20no\x20perder\x20su\x20contenido,\x20guárdelo\x20localmente\x20y\x20actualice\x20el\x20editor.',
      'The\x20local\x20document\x20and\x20server\x20document\x20differ\x20and\x20merging\x20them\x20can\x20cause\x20unexpected\x20behavior.\x20To\x20not\x20lose\x20your\x20content\x20save\x20it\x20locally\x20and\x20refresh\x20the\x20editor.':
        'El\x20documento\x20local\x20y\x20el\x20documento\x20del\x20servidor\x20difieren.\x20Fusionarlos\x20puede\x20provocar\x20un\x20comportamiento\x20inesperado.\x20Para\x20no\x20perder\x20su\x20contenido,\x20guárdelo\x20localmente\x20y\x20actualice\x20el\x20editor.',
      'Go\x20to\x20next\x20page': 'Ir\x20a\x20la\x20página\x20siguiente',
      'Go\x20to\x20previous\x20page': 'Ir\x20a\x20la\x20pagina\x20anterior',
      'Current\x20page\x20number\x20(from\x201\x20to\x20%0)':
        'Número\x20de\x20página\x20actual\x20(de\x201\x20a\x20%0)',
      'Keystrokes\x20for\x20navigating\x20through\x20documents':
        'Pulsaciones\x20de\x20teclas\x20para\x20navegar\x20por\x20los\x20documentos',
      'Go\x20to\x20the\x20previous\x20page\x20(also\x20move\x20selection)':
        'Ir\x20a\x20la\x20página\x20anterior\x20(también\x20mover\x20selección)',
      'Go\x20to\x20the\x20next\x20page\x20(also\x20move\x20selection)':
        'Ir\x20a\x20la\x20página\x20siguiente\x20(también\x20mover\x20selección)',
      'Multi-level\x20List': 'Lista\x20multinivel',
      'Multi-level\x20list\x20styles\x20toolbar':
        'Barra\x20de\x20herramientas\x20de\x20estilos\x20de\x20listas\x20multinivel',
      'Import\x20from\x20Word': 'Importar\x20desde\x20Word',
      'An\x20error\x20occurred\x20while\x20importing\x20the\x20Word\x20file.':
        'Se\x20ha\x20producido\x20un\x20error\x20al\x20importar\x20el\x20archivo\x20de\x20Word.',
      'Importing\x20Word\x20document': 'Importando\x20documento\x20de\x20Word',
      'Paint\x20formatting': 'Copiar\x20formato',
      'Copy\x20text\x20formatting': 'Copiar\x20formato\x20de\x20texto',
      'Paste\x20text\x20formatting': 'Pegar\x20formato\x20de\x20texto',
      'Continuous\x20painting': 'Copia\x20continua',
      'Keeps\x20the\x20painter\x20on\x20after\x20setting\x20the\x20formatting.':
        'Mantiene\x20la\x20copia\x20activa\x20después\x20de\x20configurar\x20el\x20formato.',
      'Formatting\x20copied.': 'Formato\x20copiado.',
      'Pasted\x20formatting.': 'Formato\x20pegado.',
      'Export\x20to\x20Word': 'Exportar\x20a\x20Word',
      'An\x20error\x20occurred\x20while\x20generating\x20the\x20Word\x20file.':
        'Se\x20ha\x20producido\x20un\x20error\x20al\x20generar\x20el\x20archivo\x20de\x20Word.',
      'Word\x20document\x20export\x20started':
        'La\x20exportación\x20del\x20documento\x20de\x20Word\x20ha\x20comenzado',
      'Word\x20document\x20export\x20failed':
        'La\x20exportación\x20del\x20documento\x20de\x20Word\x20ha\x20fallado',
      'Word\x20document\x20export\x20successful':
        'Se\x20ha\x20exportado\x20el\x20documento\x20de\x20Word',
      'Exporting\x20Word\x20document': 'Exportando\x20documento\x20de\x20Word',
      'Export\x20to\x20PDF': 'Exportar\x20a\x20PDF',
      'An\x20error\x20occurred\x20while\x20generating\x20the\x20PDF.':
        'Se\x20ha\x20producido\x20un\x20error\x20al\x20generar\x20el\x20archivo\x20PDF.',
      'PDF\x20export\x20started':
        'La\x20exportación\x20del\x20PDF\x20ha\x20comenzado',
      'PDF\x20export\x20failed':
        'La\x20exportación\x20del\x20PDF\x20ha\x20fallado',
      'PDF\x20export\x20successful': 'Se\x20ha\x20exportado\x20el\x20PDF',
      'Exporting\x20PDF\x20document': 'Exportando\x20documento\x20PDF',
      'Empty\x20heading': 'Encabezado\x20vacío',
      'Editor\x20headings\x20will\x20appear\x20here\x20as\x20you\x20type.':
        'Los\x20encabezados\x20del\x20editor\x20aparecerán\x20aquí\x20mientras\x20escribe.',
      'No\x20headings\x20were\x20found\x20in\x20the\x20document.':
        'No\x20se\x20han\x20encontrado\x20encabezados\x20en\x20el\x20documento.',
      'Table\x20of\x20contents': 'Tabla\x20de\x20contenido',
      'Comment\x20editor': 'Editor\x20de\x20comentarios',
      NUMBER_OF_COMMENTS: [
        '%0\x20comentario',
        '%0\x20comentarios',
        '%0\x20comentarios',
      ],
      TOO_LONG_COMMENT_ALERT:
        'El\x20contenido\x20del\x20comentario\x20es\x20demasiado\x20extenso.\x20Su\x20comentario\x20tiene\x20%0\x20caracteres,\x20pero\x20el\x20límite\x20es\x20de\x20%1.',
      'Reply...': 'Responder…',
      'Reply\x20to\x20reopen\x20discussion...':
        'Responder\x20para\x20reabrir\x20la\x20discusión...',
      'Write\x20a\x20comment...': 'Escribir\x20un\x20comentario…',
      'Comment\x20was\x20made\x20on\x20an\x20element':
        'Se\x20hizo\x20un\x20comentario\x20sobre\x20un\x20elemento.',
      Edit: 'Editar',
      Resolve: 'Resolver',
      Reopen: 'Reabrir',
      Remove: 'Quitar',
      Reply: 'Responder',
      'Delete\x20comment?': '¿Quiere\x20eliminar\x20el\x20comentario?',
      'Delete\x20comment\x20thread?':
        '¿Quiere\x20eliminar\x20el\x20hilo\x20de\x20comentarios?',
      'Marked\x20as\x20resolved': 'Se\x20ha\x20marcado\x20como\x20resuelto',
      Comment: 'Comentario',
      ENTER_COMMENT_ANNOUNCEMENT: 'Introduciendo\x20un\x20comentario.',
      LEAVE_COMMENT_ANNOUNCEMENT: 'Abandonando\x20un\x20comentario.',
      PENDING_ACTION_COMMENT_THREAD:
        'Cambio\x20no\x20guardado\x20en\x20hilo\x20de\x20comentarios.',
      EXTERNAL_COMMENT:
        'Este\x20comentario\x20procede\x20de\x20una\x20fuente\x20externa.',
      EXTERNAL_IMPORT_WORD_COMMENT:
        'Este\x20comentario\x20proviene\x20de\x20un\x20archivo\x20Word\x20importado.',
      EXTERNAL_AVATAR:
        'El\x20nombre\x20de\x20autor\x20que\x20se\x20muestra\x20proviene\x20de\x20una\x20fuente\x20externa\x20(agregado\x20por\x20%0\x20)',
      EXTERNAL_IMPORT_WORD_AVATAR:
        'El\x20nombre\x20de\x20autor\x20que\x20se\x20muestra\x20proviene\x20de\x20un\x20documento\x20de\x20Word\x20importado\x20por\x20%0',
      COMMENTS_ARCHIVE: 'Archivo\x20de\x20comentarios',
      EMPTY_COMMENTS_ARCHIVE:
        'No\x20hay\x20hilos\x20de\x20comentarios\x20archivados.',
      Anonymous: 'Anónimo',
      Yes: 'Sí',
      No: 'No',
      'Are\x20you\x20sure?': '¿Lo\x20confirma?',
      'Case\x20change': 'Cambio\x20de\x20mayúsculas/minúsculas',
      UPPERCASE: 'MAYÚSCULAS',
      lowercase: 'minúscula',
      'Title\x20Case': 'Titulo\x20del\x20caso',
      'Change\x20text\x20case':
        'Cambia\x20las\x20mayúsculas\x20y\x20minúsculas\x20del\x20texto',
      'Changed\x20case\x20to\x20%0': 'Se\x20ha\x20cambiado\x20a\x20%0',
      'Edit\x20or\x20review': 'Editar\x20o\x20revisar',
      'Improve\x20writing': 'Mejorar\x20la\x20escritura',
      'Make\x20shorter': 'Hacerlo\x20más\x20corto',
      'Make\x20longer': 'Hacerlo\x20más\x20largo',
      'Simplify\x20language': 'Simplificar\x20el\x20lenguaje',
      'Generate\x20from\x20selection':
        'Generar\x20a\x20partir\x20de\x20la\x20selección',
      Summarize: 'Resumir',
      Continue: 'Continuar',
      'Change\x20tone': 'Cambiar\x20el\x20tono',
      Professional: 'Profesional',
      Casual: 'Informal',
      Direct: 'Directo',
      Confident: 'Seguro',
      Friendly: 'Amistoso',
      'Change\x20style': 'Cambiar\x20el\x20estilo',
      Business: 'Negocios',
      Legal: 'Legal',
      Journalism: 'Periodismo',
      Poetic: 'Poético',
      Translate: 'Traducir',
      'Translate\x20to\x20%0': 'Traducir\x20a\x20%0',
      English: 'inglés',
      Spanish: 'español',
      German: 'alemán',
      Portuguese: 'portugués',
      French: 'francés',
      'Simplified\x20Chinese': 'chino\x20simplificado',
      Hindi: 'hindi',
      Arabic: 'árabe',
      'AI\x20Assistant': 'Asistente\x20de\x20la\x20IA',
      'AI\x20Commands': 'Comandos\x20de\x20la\x20IA',
      'Ask\x20AI\x20to\x20edit\x20or\x20generate':
        'Pedir\x20a\x20la\x20IA\x20que\x20edite\x20o\x20genere',
      'Ask\x20AI\x20to\x20improve\x20generated\x20text':
        'Pedir\x20a\x20la\x20IA\x20que\x20mejore\x20el\x20texto\x20generado',
      Copy: 'Copiar',
      Submit: 'Enviar',
      'Insert\x20below': 'Insertar\x20debajo',
      'Try\x20again': 'Intentar\x20otra\x20vez',
      Stop: 'Detener',
      'AI\x20is\x20writing...': 'La\x20IA\x20está\x20escribiendo...',
      'AI\x20is\x20writing': 'La\x20IA\x20está\x20escribiendo',
      'Generated\x20content:\x20%0': 'Contenido\x20generado:\x20%0',
      'Error\x20during\x20AI\x20content\x20generation:\x20%0':
        'Error\x20durante\x20la\x20generación\x20de\x20contenido\x20de\x20la\x20IA:\x20%0',
      History: 'Historial',
      'Empty\x20history': 'Historial\x20vacío',
      'Ask\x20AI\x20and\x20your\x20prompts\x20will\x20be\x20listed\x20here\x20for\x20you\x20to\x20use\x20later.':
        'Pregunta\x20a\x20la\x20IA\x20y\x20tus\x20indicaciones\x20aparecerán\x20aquí\x20para\x20que\x20puedas\x20usarlas\x20más\x20tarde.',
      'Prompt\x20history': 'Historial\x20rápido',
      'Search\x20AI\x20command': 'Buscar\x20comando\x20de\x20IA',
      'No\x20commands\x20found': 'No\x20se\x20han\x20encontrado\x20comandos',
      'No\x20commands\x20available': 'No\x20hay\x20comandos\x20disponibles',
      '%0\x20commands\x20found': 'Se\x20han\x20encontrado\x20%0\x20comandos',
      AI_REPLACE_CONTENT: 'Reemplazar',
      AI_INSERT_CONTENT: 'Insertar',
      AI_ERROR_GET_HEADERS:
        'Error\x20al\x20preparar\x20los\x20encabezados\x20de\x20la\x20solicitud',
      AI_ERROR_GET_PARAMETERS:
        'Error\x20al\x20preparar\x20los\x20parámetros\x20de\x20la\x20solicitud',
      AI_ERROR_UNSUPPORTED_MODEL:
        'El\x20modelo\x20de\x20IA\x20solicitado\x20(\x22%0\x22)\x20no\x20es\x20compatible',
      AI_ERROR_CONTEXT_LENGTH:
        'El\x20contenido\x20seleccionado\x20es\x20muy\x20largo',
      AI_ERROR_MODERATION:
        'La\x20consulta\x20solicitada\x20no\x20cumple\x20las\x20reglas\x20de\x20moderación',
      AI_ERROR_FAILED:
        'Ha\x20fallado\x20la\x20comunicación\x20con\x20el\x20servicio\x20de\x20IA',
    },
    getPluralForm: (_0x56f74c) =>
      _0x56f74c == 0x1
        ? 0x0
        : _0x56f74c != 0x0 && _0x56f74c % 0xf4240 == 0x0
        ? 0x1
        : 0x2,
  },
};
